import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://ubnsbjqmjwgoyqlyhmuf.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVibnNianFtandnb3lxbHlobXVmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYxMzM3NTMsImV4cCI6MjA5MTcwOTc1M30.vFmOxJLYneyKea5MIT-XdDwryOHkYIdEkyUiWgYlBCY';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
